// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__eq2nD","icon":"SortAdornment_icon__3Yisr","up":"SortAdornment_up__2dDBH","down":"SortAdornment_down__2IRYu","active":"SortAdornment_active__PTF4W"};